export const getTypes = (state) => state.types.types;
